import { PublicCompanyDto } from '~/swagger/Api';
import { CompanyInfo } from '~/types/CompanyInfo';
import { createCompanyStyleFromTheme } from '~/utils/companyStyle';
import { Gateway } from './gateway';
import { baseNetworkManager } from './network/baseNetworkManager';
import { MagicRequest, RequestMethod } from './network/magicRequest';

const ACCOUNTS_URL = '/api/companies/info';

class CompanyGateway extends Gateway {
  public getCompanyInfo = async (domain: string): Promise<CompanyInfo> => {
    const request: MagicRequest = {
      url: ACCOUNTS_URL + `?domain=${domain}`,
      method: RequestMethod.GET,
      headers: this.createCommonHeaders(),
    };
    const response: Response = await this.sendRequest(request);
    const json = await response.json();
    return this.createCompanyInfoFromJson(json);
  };

  private createCompanyInfoFromJson(json: PublicCompanyDto): CompanyInfo {
    return {
      id: json.id,
      name: json.name,
      email: json.email,
      url: json.subUrl,
      language: json.language,
      phoneNumber: json.phoneNumber,
      timeZone: json.timeZoneInfo,
      style: createCompanyStyleFromTheme(json.settings.metadata.theme),
      logo: json.settings.logoUrl ?? undefined,
      customDomain: json.customDomain ?? undefined,
    };
  }

  public getLanguages = async (): Promise<{ name: string; code: string }[]> => {
    const request: MagicRequest = {
      url: '/api/public/languages',
      method: RequestMethod.GET,
      headers: this.createCommonHeaders(),
    };
    const response: Response = await this.sendRequest(request);
    return await response.json();
  };
}

export const companyGateway = new CompanyGateway(baseNetworkManager);
